import { Component, OnInit } from '@angular/core';


import { Routes, RouterModule } from '@angular/router';


import { Observable , from} from 'rxjs';
import { CategorieService } from 'my-lib-sanfelici';
import { Categoria } from 'my-lib-sanfelici';




@Component({
  selector: 'app-categorie-list',
  templateUrl: './categorie-list.component.html',
  styleUrls: ['./categorie-list.component.css'], providers : [CategorieService]
})
export class CategorieListComponent implements OnInit {
    categorie: Observable<Categoria[]>;
    categoria: Categoria;

    constructor(
public _categorieService: CategorieService) { }

    cancel(id) {
        this._categorieService.delete(id);
    }

    ngOnInit() {

        this.categorie = this._categorieService.list();


    }

}
